import type { HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { I18nService } from '@core/i18n-legacy';
import { NotificationsController } from '@core/user-interface-legacy';

@Injectable({ providedIn: 'root' })
export class HttpErrorHandlerService {
  private readonly notificationsCtrl = inject(NotificationsController);
  private readonly i18nService = inject(I18nService);

  public default(errorResponse: HttpErrorResponse): void {
    errorResponse.error && errorResponse.error.error && errorResponse.error.error.length
      ? errorResponse.error.error.forEach((message: string) => {
          this.notificationsCtrl.error(message);
        })
      : this.notificationsCtrl.error(this.i18nService.translate('rti.common.request_error'));
  }
}
